import styled from 'styled-components';
import colors from 'constants/colors';

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: transparent;

  .label {
    font-size: 13px;
    font-weight: 600;
    color: ${colors.silver};
    letter-spacing: 1px;
    margin-bottom: 5px;
    white-space: nowrap;
  }

  input {
    color: ${(props) => (props.disabled? colors.silver: colors.white)};
    background-color: ${(props) => (props.disabled? colors.dimGrey: props.mainPage ? 'transparent' : colors.black2)};
    font-size: 14px;
    font-weight: 600;
    padding: 9px;
    border: 1px solid ${(props) => props.disabled? colors.silver: props.error? colors.red: colors.darkGrey};
    width: 100%;
    height: 40px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    letter-spacing: 0.5px;
    &:-internal-autofill-selected, :-webkit-autofill, :-webkit-autofill:hover, :-webkit-autofill:focus {
      -webkit-box-shadow: 0 0 0 500px ${(props) => (props.mainPage ? colors.black2 : colors.black2)} inset !important;
      -webkit-text-fill-color: ${(props) => (props.disabled? colors.silver: colors.white)} !important;
    }
    &:-moz-autofill {
      background-color: ${(props) => (props.mainPage ? colors.black2 : colors.black2)} !important;
      color:  ${(props) => (props.disabled? colors.silver: colors.white)} !important; 
    }

    :focus-visible {
      outline: none;
      background-color: ${colors.black1};
    }

    :disabled {
      padding: 9px;
    }
  }

  input::placeholder {
    font-weight: 300;
    font-style: italic;
    letter-spacing: 1px;
    color: ${colors.white};
  }

  .warning {
    width: 100%;
    height: 20px;
    line-height: 20px;
    color: ${colors.red};
    font-size: 14px;
    font-weight: 600;
    white-space: normal;
    word-wrap: break-word; 
    word-break: break-all;
    overflow: visible;
    text-align: left;
    margin-top: 5px;
  }

  ${(props) => props.additionalstyle};
`;
